<template>
  <button @click="$emit('click')" type="button" class=" text-center items-center px-4 py-2 border border-transparent text-base font-medium
  rounded-md shadow-sm text-white bg-brand-danger hover:opacity-75 focus:outline-none focus:ring-2 focus:ring-offset-2
  focus:ring-indigo-500" v-html="text">

  </button>
</template>

<script>
import buttonMixin from "@/components/Functional/Buttons/buttonMixin";

export default {
  name: "DangerButton",
  mixins: [buttonMixin]
}
</script>

<style scoped>

</style>